import React from "react";
import { connectAutoComplete } from "react-instantsearch/connectors";
import AutoComplete from "../AutoComplete";
import SupportingText from "../SupportingText";

class ConnectedAutoComplete extends React.Component {
  handleStateChange = (changes, state) => {
    const { refine, onInputChange } = this.props;

    const { inputValue } = state;
    if (Object.prototype.hasOwnProperty.call(changes, "inputValue")) {
      onInputChange(inputValue);
      refine(inputValue);
    }
  };

  handleChange = selectedItem => {
    const { refine } = this.props;
    if (selectedItem) {
      refine(selectedItem.articleID);
    }
  };

  render() {
    const { hits, maxHeight, handleFocus, handleBlur } = this.props;
    return (
      <AutoComplete
        maxHeight={maxHeight}
        itemToString={item => (item ? item.articleID : "")}
        onChange={this.handleChange}
        items={hits}
        onStateChange={this.handleStateChange}
        placeholder="Artikelnummer"
        handleFocus={handleFocus}
        handleBlur={handleBlur}
        renderItems={item => (
          <div className="w-full">
            <div className="pt-1">
              <SupportingText fontWeight="normal" textColor="text-grey-darkest">
                {item.articleID}
              </SupportingText>
            </div>
            <div className="pt-1">
              <SupportingText fontWeight="thin" textColor="text-grey-darker">
                {item.brand}
              </SupportingText>
            </div>
          </div>
        )}
      />
    );
  }
}

export default connectAutoComplete(ConnectedAutoComplete);



// WEBPACK FOOTER //
// ./src/ConnectedAutoComplete/ConnectedAutoComplete.js